export default "__VITE_ASSET__n7R1YCcm__"